import {useCallback} from 'react';
import {ModuleTopic} from '@cp/model';
import getModuleTopicsWithStudyDoc from '../../api/study/getModuleTopicsWithStudyDoc';
import {useFunctionRun} from '../helper/function/useFunctionRun';

export interface GetModuleTopicsWithStudyVariables {
  moduleId: string;
}

export function useGetModuleTopicsWithStudy() {
  const load = useCallback(
    async (variables: GetModuleTopicsWithStudyVariables): Promise<ModuleTopic[]> =>
      getModuleTopicsWithStudyDoc(variables.moduleId),
    [],
  );

  const {data, loading, error, refetch} = useFunctionRun(load, {
    skipLoadOnMount: true,
  });

  const getModuleTopicsWithStudy = (moduleId: string) => {
    return refetch({moduleId});
  };

  return {
    topics: data || [],
    loading,
    error,
    getModuleTopicsWithStudy,
  };
}
